export default __webpack_public_path__ + "static/media/main_3.c58bd727.jpeg";